import { useEffect, useState } from "react";
import {
  Card,
  Form,
  Row,
  Col,
  Checkbox,
  Input,
  Divider,
} from "antd";

import service from "src/services/citizenScienceService";
import { recordError } from "src/utils/logService";
import {
  csParticipRoleEnum,
  util
} from '@seims/shared';

export default function ParticipantsRoles({ onSetNextStatus, formRef, data }) {
  const [form] = Form.useForm();
  const formName = "ParticipantRolesForm";
  const formItemLayout = {
    layout: "vertical",
  };

  const [checkedConceptualList, setCheckedConceptualList] = useState([]);
  const [checkedRoleList, setCheckedRoleList] = useState([]);
  const [checkedDuringRoleList, setCheckedDuringRoleList] = useState([]);
  const [checkedAfterRoleList, setCheckedAfterRoleList] = useState([]);
  const [showOtherRole, setShowOtherRole] = useState(false);
  const [showOtherDuringProject, setShowOtherDuringProject] = useState(false);
  const [showOtherAfterProject, setShowOtherAfterProject] = useState(false);

  const [postProject, setPostProject] = useState([]);
  const [selectedPostProject, setSelectedPostProject] = useState([]);

  const [duringProject, setDuringProject] = useState([]);
  const [selectedDuringProject, setSelectedDuringProject] = useState([]);

  const [projectRecognition, setProjectRecognition] = useState([]);
  const [selectedProjectRecognition, setSelectedProjectRecognition] = useState(
    []
  );
  const [conceptualisationRolePost, setConceptualisationRolePost] = useState(
    []
  );

  useEffect(() => {
    getConceptualizationStageRoles();
    getProjectParticipantRolesPost();
    getProjectParticipantRolesDuring();
    getProjectContributionRecognition();

    loadProjectParticipantRoles();
  }, []);

  const transformKeyValue = (keyValues) => {
    return keyValues?.map((d) => {
      return {
        label: d.value,
        value: d.key,
        key: d.key,
      };
    });
  };

  const loadProjectParticipantRoles = () => {
    if (!util.isEmpty(data)) {
      const _post = data.rolesPostProject?.map((d) => d.key);
      setSelectedPostProject(_post);

      const _recognition = data.contributionRecognition?.map((d) => d.key);
      setSelectedProjectRecognition(_recognition);

      const _during = data.rolesDuringProject?.map((d) => d.key);
      setSelectedDuringProject(_during);

      const _pre = data.rolesPreProject?.map((d) => d.key);

      form.setFieldsValue({
        rolesDuringProject: _during,
        rolesPostProject: _post,
        contributionRecognition: _recognition,
        conceptualisation: _pre,
      });
    }
  };

  const getConceptualizationStageRoles = async () => {
    try {
      const response = await service.getProjectParticipantRoles(
        csParticipRoleEnum.CONCEPTUALISATION
      );
      if (response) {
        const { data } = response;
        const transformData = data.map((c) => ({
          label: c.value,
          value: c.key,
          key: c.key,
        }));
        setConceptualisationRolePost(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onChangeOtherRole = (e) => {
    const { value: text } = e.target;
    const id = checkedRoleList.indexOf("Other");
    if (id !== -1) checkedRoleList[id] = text;
  };
  const onChangeOtherDuring = (e) => {
    const { value: text } = e.target;
    const id = checkedDuringRoleList.indexOf("Other specify");
    if (id !== -1) checkedDuringRoleList[id] = text;
  };
  const onChangeOtherAfter = (e) => {
    const { value: text } = e.target;
    const id = checkedAfterRoleList.indexOf("Other specify");
    if (id !== -1) checkedAfterRoleList[id] = text;
  };

  const getProjectParticipantRolesPost = async () => {
    try {
      const response = await service.getProjectParticipantRoles(
        csParticipRoleEnum.POST
      );
      if (response && response.status === 200) {
        const { data } = response;
        const treeData = transformKeyValue(data);
        setPostProject(treeData);
      }
    } catch (error) {
      recordError(error);
    }
  };
  const getProjectParticipantRolesDuring = async () => {
    try {
      const response = await service.getProjectParticipantRoles(
        csParticipRoleEnum.DURING
      );
      if (response && response.status === 200) {
        const { data } = response;
        const treeData = transformKeyValue(data);
        setDuringProject(treeData);
      }
    } catch (error) {
      recordError(error);
    }
  };
  const getProjectContributionRecognition = async () => {
    try {
      const response = await service.getProjectContributionRecognition();
      if (response && response.status === 200) {
        const { data } = response;
        const treeData = transformKeyValue(data);
        setProjectRecognition(treeData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onChangeConceptualisation = (keys) => {
    setCheckedConceptualList(keys);
  };

  const handleSelectedPostProject = (data) => {
    if (selectedPostProject.find((post) => post.key === data.key)) {
      return true;
    } else {
      return false;
    }
  };
  const handleSelectedDuringProject = (data) => {
    if (selectedDuringProject.find((during) => during.key === data.key)) {
      return true;
    } else {
      return false;
    }
  };

  const handleSelectedProjectRecognition = (data) => {
    if (
      selectedProjectRecognition?.find(
        (recognition) => recognition.key === data.key
      )
    ) {
      return true;
    } else {
      return false;
    }
  };

  const onChangeDuringProject = (selectedValue) => {
    const selectedOptions = duringProject?.filter((c) =>
      selectedValue.includes(c.key)
    );
    const otherSelected = selectedOptions.some(
      (c) => c.label === "Other specify"
    );

    if (otherSelected) {
      setShowOtherDuringProject(true);
    } else {
      setShowOtherDuringProject(false);
    }
    // setSelectedDuringProject(selectedOptions)
  };

  const onSubmit = async (values) => {
    // try {
    const participantRoles = {
      "During project": values.duringProject,
      "Post project": values.postProject,
      Roles: values.roles,
    };
  };

  return (
    <>
      <Card
        className="project-card"
        title={
          <span
            style={{ color: "black", fontWeight: "bold", fontSize: "20px" }}
          >
            <b>STEP 4: Citizen Scientist Roles</b>
          </span>
        }
        bordered={false}
        headStyle={{ border: 0, textAlign: "left" }}
      >
        <Form
          {...formItemLayout}
          name={formName}
          form={form}
          onFinish={onSubmit}
          scrollToFirstError
          disabled={true}
          // ref={formRef}
        >
          <Row>
            <Col>
              <Form.Item
                name="conceptualisation"
                label="Conceptualisation Stage"
              >
                <Checkbox.Group
                  onChange={onChangeConceptualisation}
                  options={conceptualisationRolePost}
                  style={{ display: "flex", flexDirection: "column" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Item name="rolesDuringProject" label="During project">
                <Checkbox.Group
                  onChange={onChangeDuringProject}
                  options={duringProject}
                  style={{ display: "flex", flexDirection: "column" }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Item name="rolesPostProject" label="Post project">
                <Checkbox.Group
                  style={{ display: "flex", flexDirection: "column" }}
                  options={postProject}
                />
              </Form.Item>
            </Col>
          </Row>
          {showOtherAfterProject && (
            <Row>
              <Col>
                <Form.Item
                  name="otherRoleAfterProject"
                  label="Please enter other role after project"
                >
                  <Input onBlur={onChangeOtherAfter} />
                </Form.Item>
              </Col>
            </Row>
          )}
          <Divider />

          <Row>
            <Col>
            <p style={{ textAlign: "left"}}>
              Contribution recognition
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Item name="contributionRecognition">
                <Checkbox.Group
                  style={{ display: "flex", flexDirection: "column" }}
                  options={projectRecognition}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* </Card> */}
        </Form>
      </Card>
    </>
  );
}
